import {useState, useEffect} from 'react';
import {
    AppBar,
    Toolbar,
    Box,
    Typography,
    Card,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    TextField
} from '@mui/material';
import { VerticalSpace } from '../components';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams } from 'react-router-dom';
import RPC from '../assets/web3RPC';

const ColorsArray = ["#EF9A9A", "#F48FB1", "#CE93D8", "#B39DDB", "#9FA8DA", "#90CAF9", "#81D4FA", "#80DEEA"]

const KidCard = ({ id, name, color, testDoc }) => {
    const navigate = useNavigate()

    const onCardClick = () => {
        if(!testDoc || testDoc === 'null' || testDoc === 'undefined')
            return null;
        
        navigate(`/${testDoc}?kid=${id}`)
    }

    return (
        <Paper sx={{
            background: color,
            display: 'flex',
            alignItems: 'flex-end',
            minWidth: "200px",
            height: "100px",
            padding: "20px",
            margin: "10px",
            borderRadius: "10px",
            overflow: 'hidden',
            cursor: 'pointer'
        }} 
        onClick = {onCardClick}
        >
            <Typography
                variant='h5'
                sx={{
                    textAlign: 'left',
                    fontWeight: 700
                }}
            >
                {name}
            </Typography>
        </Paper>
    )
}

const AdminAssessmentRow = ({recording, index, callback}) => {
    const [points, setPoints] = useState(0);

    const updateScore = async () => {
        try {
            toast.info('Loading', {autoClose: false})
            const {data} = await axios.post('https://dapp-backend.triadkube.com/auth/update-assessment-score', {points, id: recording._id})

            toast.dismiss()
            toast.success("Score updated successfully")
            callback()
        } catch (error) {
            toast.error("Something went wrong")
        }
    }
    return (
        <TableRow key={recording._id} sx={{ '&:last-child td, &:last-child th': { border: 0 }, backgroundColor: recording.manuallyAssessed?'#CFD8DC':'#FFFFFF' }} >
            <TableCell component="th" scope="row">{index+1}.</TableCell>
            <TableCell align="left">{moment(recording.createdOn).local().format("DD MMM YYYY hh:mma")}</TableCell>
            <TableCell align="left">{recording?.participant?.name}</TableCell>
            <TableCell align="left">{recording.platform.toUpperCase()} - {recording.module.toUpperCase()}</TableCell>
            <TableCell align="left"><audio controls={true}><source src={recording.link+`#t=00:00:${Math.round(recording.answerTimestamp)}`}  /></audio></TableCell>
            <TableCell align="left"><a href={recording.pptLink}>Click Here</a></TableCell>
            <TableCell align="left">
                {
                    recording.manuallyAssessed
                    ?
                    `Assessment Verified`
                    :
                    <Box sx={{display: 'flex', alignItems: 'flex-end'}} >
                        <TextField label="Points" variant="standard" value={points} onChange={(evt) => setPoints(evt.target.value)} />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Button variant="contained" disabled={!points} onClick={updateScore} >Update Score</Button>
                    </Box>
                }
            </TableCell>
        </TableRow>
    )
}

const Dashboard = ({web3Auth, provider, setProvider}) => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const [accountId, setAccountId] = useState(localStorage.getItem('brainsprays-accountId'))
    const [profile, setProfile] = useState({});
    const [kids, setKids] = useState([])
    const [walletBalance, setWalletBalance] = useState(0);
    const [cryptoAccount, setCryptoAccount] = useState("");
    const [pastRecording, setPastRecordings] = useState([])
    const [allAssessments, setAllAssessments] = useState([])

    const logout = async () => {
        if (!web3Auth) {
            console.log("web3auth not initialized yet");
            return;
        }
        await web3Auth.logout();
        setProvider(null);
        localStorage.setItem('brainsprays-accountId', '')
    }
    const getWallet = async () => {
        if (!provider) {
            console.log("provider not initialized yet");
            return;
        }

        const rpc = new RPC(provider);
        const balance = await rpc.getBalance();
        // console.log("WALLET", balance)
        setWalletBalance(balance)
    }

    const getCryptoAccount = async () => {
        if (!provider) {
            console.log("provider not initialized yet");
            return;
        }
        const rpc = new RPC(provider);
        const address = await rpc.getAccounts();
        const chainId = await rpc.getChainId();
        // console.log("ACCOUNT", address, chainId, provider);

        if(!address) {
            localStorage.setItem('brainsprays-accountId', '')
            navigate(`/login?testDoc=${searchParams.get('testDoc')}`)
        }
        setCryptoAccount(address)
    }

    const getKids = async () => {
        try {
            const {data} = await axios.get(`https://dapp-backend.triadkube.com/auth/list-kids/${accountId || searchParams.get('id')}`)

            setKids(data.result)
        } catch (error) {
            toast.error("Something went wrong")
        }
    }

    const getAllAssessments = async () => {
        try {
            const {data} = await axios.get('https://dapp-backend.triadkube.com/auth/all-assessments')

            setAllAssessments(data.result)
        } catch (error) {
            toast.error("Something went wrong")
        }
    }

    const getPastRecording = async () => {
        try {
            const kidsList = kids.map(kid => kid._id).toString()
            const {data} = await axios.get(`https://dapp-backend.triadkube.com/auth/past-recordings?kids=${kidsList}`)

            setPastRecordings(data.result)
        } catch (error) {
            toast.error("Something went wrong")
        }
    }

    const getProfile = async () => {
        try {
            const {data} = await axios.get(`https://dapp-backend.triadkube.com/auth/get-profile/${accountId}`)

            setProfile(data.result)
        } catch (error) {
            toast.error("Something went wrong")
        }
    }

    useEffect(() => {
        const testDoc = searchParams.get('testDoc')

        if(kids.length && (!testDoc || testDoc === 'null' || testDoc === 'undefined'))
            getPastRecording()
    }, [kids])

    useEffect(() => {
        if(profile?.role === 'PARENT')
            getKids()
        else 
            getAllAssessments()
    }, [profile])

    useEffect(() => {
        if(provider) {
            getCryptoAccount()
            getWallet()
        }
    }, [provider])

    useEffect(() => {
        if(searchParams.get('id')) {
            localStorage.setItem('brainsprays-accountId', searchParams.get('id'))
        }

        getProfile()
    }, [])

    // console.log("PAST RECORDINGS", pastRecording)

    return (
        <Box
            sx={{
                flex: '1',
                display: 'block',
                height: '100vh',
            }}
        >
            <AppBar position="fixed">
                <Toolbar>
                    <Typography
                        variant='h5'
                        sx={{
                            textAlign: 'left',
                            fontWeight: 700
                        }}
                    >
                        Dashboard
                    </Typography>
                    <Box sx={{flex: 1, display: 'flex', justifyContent: 'flex-end'}} >
                        <Button variant='contained' onClick={() => navigate('/leaderboard')} sx={{backgroundColor: '#FFFFFF', color: '#1E88E5', '&:hover': {backgroundColor: '#E0E0E0'}}} >Leaderboard</Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button variant='contained' onClick={logout} sx={{backgroundColor: '#FFFFFF', color: '#1E88E5', '&:hover': {backgroundColor: '#E0E0E0'}}} >Logout</Button>
                    </Box>
                </Toolbar>
            </AppBar>
            <VerticalSpace count={10} />
            {
                profile.role === 'PARENT'
                ?
                <Card
                    sx={{
                        width: 'calc(100% - 100px)',
                        padding: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Typography variant='h6' >Account ID: {cryptoAccount}</Typography>
                    <Typography variant='h6' >Account Balance: {walletBalance} MATIC</Typography>
                </Card>
                :
                null
            }
            <VerticalSpace count={2} />
            {
                profile?.role === 'PARENT'
                ?
                <Card
                    sx={{
                        width: 'calc(100% - 100px)',
                        padding: '50px',
                    }}
                >
                    <Typography
                        variant='h4'
                        sx={{
                            textAlign: 'left',
                            fontWeight: 700
                        }}
                    >
                        Who's taking the assessment?
                    </Typography>
                    <VerticalSpace count={2} />
                    <Box
                        sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            marginLeft: '20px'
                        }}
                    >
                        {
                            kids.map((kid, index) => (<KidCard key={kid._id} name={kid.name} id={kid._id} testDoc={searchParams.get('testDoc')} color={ColorsArray[index%8]} />))
                        }
                        <Paper sx={{
                            background: '#1E88E5',
                            display: 'flex',
                            alignItems: 'flex-end',
                            minWidth: "200px",
                            height: "100px",
                            padding: "20px",
                            margin: "10px",
                            borderRadius: "10px",
                            overflow: 'hidden',
                            cursor: 'pointer'
                        }}
                        onClick={() => navigate(`/create-kid-profile?id=${accountId}&testDoc=${searchParams.get('testDoc')}`)}
                        >
                            <Typography
                                variant='h5'
                                sx={{
                                    textAlign: 'center',
                                    fontWeight: 700,
                                    color: '#FFF'
                                }}
                            >
                                Add Profile
                            </Typography>
                        </Paper>
                    </Box>
                </Card>
                :
                null
            }
            <VerticalSpace count={5} />
            {
                profile?.role === 'PARENT' && (!searchParams.get('testDoc') || searchParams.get('testDoc') === 'null' || searchParams.get('testDoc') === 'undefined')
                ?
                <Box>
                    <Typography
                        variant='h6'
                        sx={{
                            textAlign: 'left',
                            fontWeight: 700
                        }}
                    >
                        Your Past Recordings
                    </Typography>
                    <VerticalSpace count={1} />
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sl. No</TableCell>
                                    <TableCell >Date</TableCell>
                                    <TableCell >Kid</TableCell>
                                    <TableCell >Module</TableCell>
                                    <TableCell >Audio Link</TableCell>
                                    <TableCell >Presentation</TableCell>
                                    <TableCell >Points</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {
                                pastRecording.map((recording, index) => {
                                    return (
                                        <TableRow key={recording._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            <TableCell component="th" scope="row">#{index+1}</TableCell>
                                            <TableCell align="left">{moment(recording.createdOn).local().format("DD MMM YYYY hh:mma")}</TableCell>
                                            <TableCell align="left">{recording.participant.name}</TableCell>
                                            <TableCell align="left">{recording.platform.toUpperCase()} - {recording.module.toUpperCase()}</TableCell>
                                            <TableCell align="left"><audio controls={true}><source src={recording.link+`#t=00:00:${Math.round(recording.answerTimestamp)}`}  /></audio></TableCell>
                                            <TableCell align="left"><a href={recording.pptLink}> Click here to open PPT</a></TableCell>
                                            <TableCell align="left">{recording.points}</TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <VerticalSpace count={3} />
                </Box>
                :
                null
            }
            {
                profile?.role === 'CREATOR'
                ?
                <Box>
                    <Typography
                        variant='h6'
                        sx={{
                            textAlign: 'left',
                            fontWeight: 700
                        }}
                    >
                        Assessments
                    </Typography>
                    <VerticalSpace count={1} />
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Sl. No</TableCell>
                                    <TableCell >Date</TableCell>
                                    <TableCell >Kid</TableCell>
                                    <TableCell >Module</TableCell>
                                    <TableCell >Audio Link</TableCell>
                                    <TableCell >Presentation</TableCell>
                                    <TableCell >Points</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {
                                allAssessments.map((recording, index) => {
                                    return <AdminAssessmentRow recording={recording} index={index} callback={getAllAssessments} />
                                })
                            }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <VerticalSpace count={3} />
                </Box>
                :
                null
            }
        </Box>
    )
}

export default Dashboard;